import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { MatDialog } from "@angular/material/dialog";
import { Data } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { IonicModule, ModalController, NavParams } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { LEAVE_SYNDICATE_FAILED } from "src/app/app.constants";
import { SeeYouSoonComponent } from "src/app/components/see-you-soon/see-you-soon.component";
import { SyndicateSummaryComponent } from "src/app/components/syndicate-summary/syndicate-summary.component";
import { WinMorePromisePopupComponent } from "src/app/components/win-more-promise-popup/win-more-promise-popup.component";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { DotFlashAnimationComponent } from "../../../components/dot-flash-animation/dot-flash-animation.component";
import { InProgressAnimationComponent } from "../../../components/in-progress-animation/in-progress-animation.component";
import { SyndicateLeaveComponent } from "../syndicate-leave/syndicate-leave.component";
import { SyndicateRepositoryService } from "../syndicate-repository.service";
import { SyndicateStatusComponent } from "../syndicate-status/syndicate-status.component";
import { TakeHolidayComponent } from "../take-holiday/take-holiday.component";
import { SyndicateVM } from "./syndicate.vm";
@Component({
  selector: "app-syndicate-setting",
  templateUrl: "./syndicate-setting.component.html",
  styleUrls: ["./syndicate-setting.component.scss"],
  standalone: true,
  imports: [
    IonicModule,
    DotFlashAnimationComponent,
    InProgressAnimationComponent,
    DatePipe,
    TranslatePipe,
  ],
})
export class SyndicateSettingComponent implements OnInit {
  syndicate: Data;
  dotAnimation: boolean;
  pageTitle = "Syndicate’s settings";
  loaded: boolean;
  paused;
  progressBar: number;
  spinnerAnimation: boolean;
  timer$: Data;
  sub: Data;
  translatedToastMsg: Data;
  selectedLanguage: string = "en";
  proceed = true;

  constructor(
    private modalCtrl: ModalController,
    private bottomSheet: MatBottomSheet,
    private navParams: NavParams,
    private matDialog: MatDialog,
    private syndicateService: SyndicateRepositoryService,
    public translate: TranslateService,
    private GTMSegment: GTMSegmentService,
    private authService: AuthService
  ) {
    try {
      this.authService.selectedlanguage$?.subscribe(
        (l) => {
          this.selectedLanguage = l;
          translate.use(l ? l : "en");
        },
        (err) => {
          return err;
        }
      );

      this.authService.getConstantsMsg$?.subscribe((msg: Data) => {
        this.translatedToastMsg = msg?.static_messages_pwa;
      });
      this.GTMSegment.GTMPopupInitialization("SyndicateSettings");
      this.syndicate = this.navParams?.data?.syndicate;
      this.syndicate["vm"] = new SyndicateVM(this.syndicate);
      this.loaded = true;
    } catch (e) {
      return e;
    }
  }

  ngOnInit() {
    try {
      this.translate.get(["syndicate-setting.pageTitle"])?.subscribe(
        (res: string) => {
          this.pageTitle = res["syndicate-setting.pageTitle"];
        },
        (err) => {
          return err;
        }
      );
    } catch (e) {
      return e;
    }
  }

  goBack() {
    this.modalCtrl.dismiss().catch((err) => {
      return err;
    });
  }

  typeCheck(draw_day) {
    return typeof draw_day;
  }

  viewSyndicateSummary(syndicateType: Data, tcObj: Data, syndicateName: string) {
    localStorage.setItem('syndicate_Name', syndicateName);
    this.bottomSheet.open(SyndicateSummaryComponent, {
      panelClass: "terms-dialog",
      backdropClass: "syndicate-summary-backdrop",
      data: { syndicateType, tcObj, syndicateName },
    });
  }

  async openSyndicateStatus(syndicateData: Data) {
    try {
      this.GTMSegment.HotJarEvent('user_manage_syndicate');
      /* open syndicate status from the syndicate settings */
      const syndicateSettings = await this.modalCtrl.create({
        component: SyndicateStatusComponent,
        cssClass: "modal-fullScreen",
        componentProps: {
          syndicateData,
        },
      });

      /* when modal syndicate modal dismissed */
      syndicateSettings.onDidDismiss().then((res: Data) => {
        try {
          if (res && res?.data?.data && res?.data?.data === "close") {
            setTimeout(() => {
              this.modalCtrl.dismiss().catch((err) => {
                return err;
              });
            }, 300);
            return;
          }
          if (res && res?.data && res?.data?.data === "syndicatePaused") {
            setTimeout(() => {
              this.modalCtrl.dismiss().catch((err) => {
                return err;
              });
            }, 300);
          }
          if (res && res?.data && res?.data?.data === "syndicatePaused") {
            return;
          }

          if (res && res?.data && res?.data?.data === "leaveReason") {
            return;
          }

          if (res && res?.data && res?.data?.data === "keepPlaying") {
            this.modalCtrl.dismiss().catch((err) => {
              return err;
            });
            return;
          }
          if (res && res?.data) {
            this.leaveSyndicateNextStep(res?.data, syndicateData);
          }
        } catch (e) {
          return e;
        }
      }).catch((err) => {
        return err;
      });

      return await syndicateSettings.present();
    } catch (e) {
      return e;
    }
  }

  private async leaveSyndicateNextStep(reason, syndicateData) {
    const syndicateHoliday = await this.modalCtrl.create({
      component: TakeHolidayComponent,
      cssClass: "modal-fullScreen",
      componentProps: {
        syndicateData,
        reason,
      },
    });
    syndicateHoliday?.onDidDismiss().then((res: Data) => {
      if (!res || !res?.data) return;
      if (res && res?.data && res?.data?.leaveFinal) {
        this.leaveSyndicate(reason, syndicateData);
        // this.leaveSyndicateConfirmation(reason, syndicateData);
      } else if (res && res?.data && !res?.data?.leaveFinal) {
        setTimeout(() => {
          this.modalCtrl.dismiss().catch((err) => {
            return err;
          });
        }, 300);
      }
    }).catch((err) => {
      return err;
    });

    return await syndicateHoliday.present();
  }

  leaveSyndicate(reason, syndicateData) {
    try {
      this.syndicateService
        .leaveSyndicate(
          syndicateData?.id
            ? syndicateData?.id
            : syndicateData?.encrypted_id
              ? syndicateData?.encrypted_id
              : syndicateData?.sId,
          syndicateData?.cardType,
          reason
        )
        ?.subscribe((response) => {
          this.progressBar === 100;
          this.sub?.unsubscribe();
          if (response?.status === "rejected") {
            this.authService.getConstantsMsg(response?.error_code).then((translatedMsg) => {
              const defaultMsg = {
                message: {
                  line_1: "Something went wrong!",
                  line_2: "",
                },
                style: {
                  icon: "tick circle error.svg",
                  type: "Error",
                },
              }
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            }).catch((error) => {
              return error;
            });
            this.modalCtrl.dismiss().catch((err) => {
              return err;
            });
            return;
          }
          if ("success" === "success") {
            const msg = this.matDialog.open(SeeYouSoonComponent, {
              height: "50%",
              data: syndicateData,
            });

            msg.afterClosed()?.subscribe(
              () => {
                this.modalCtrl.dismiss({ isSuccessLeave: true }).catch((err) => {
                  return err;
                });
              },
              (err) => {
                return err;
              }
            );
          } else {
            //this.snackService.openSnackBar(LEAVE_SYNDICATE_FAILED, "", "Error", "Error");
            //this.dialogL.close({ isSuccessLeave: false });
            setTimeout(() => {
              // this.showToast(LEAVE_SYNDICATE_FAILED, "Error");
              //this.authService.showToast(LEAVE_SYNDICATE_FAILED ? LEAVE_SYNDICATE_FAILED : "Leaving syndicate failed", "Error", "");
              const translatedMsg = {
                message: {
                  line_1: LEAVE_SYNDICATE_FAILED,
                  line_2: "",
                },
                style: {
                  duration: 2000,
                  icon: "tick circle error.svg",
                  type: "Error",
                },
              };
              const defaultMsg = {
                message: {
                  line_1: "Leaving syndicate failed",
                  line_2: "",
                },
                style: {
                  icon: "tick circle error.svg",
                  type: "Error",
                },
              };
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            }, 2000);
            this.modalCtrl.dismiss().catch((err) => {
              return err;
            });
          }

          setTimeout(() => {
            this.spinnerAnimation = false;
            this.proceed = false;
            setTimeout(() => {
              this.proceed = true;
            }, 2000);
          }, 300);
        });
    } catch (e) {
      return e;
    }
  }

  leaveSyndicateConfirmation(reason, syndicateData) {
    const leaveSyndicateConfirmation = this.matDialog.open(SyndicateLeaveComponent, {
      panelClass: "leave-syndicate-dialog",
      width: "96vh",
      position: {
        top: "18vh",
        left: "3.5vh",
      },
      backdropClass: "back-drop-color",
      data: { syndicate: syndicateData, reason: reason },
    });
    try {
      leaveSyndicateConfirmation.afterClosed()?.subscribe(
        (res: Data) => {
          if (!res) {
            return;
          }
          if (res && res?.isSuccessLeave) {
            this.modalCtrl.dismiss().catch((err) => {
              return err;
            });
          }
        },
        (err) => {
          return err;
        }
      );
    } catch (e) {
      return e
    }
  }

  viewSyndicateMemberCount(syndicate) {
    try {
      this.dotAnimation = true;
      this.syndicateService.viewPlayersCount(syndicate)?.subscribe(
        (res: Data) => {
          this.dotAnimation = false;
          if (res && res?.response && res?.response?.status === "SUCCESS") {
            this.syndicate.syndicate_size = res?.response?.syndicate_size;
          } else {
            // this.snackService.openSnackBar("something went wrong!", "", "Error", "Error");
            /*  const msg = this.translatedToastMsg?.["1015"]?.[this.selectedLanguage];
            this.authService.showToast(msg ? msg : "something went wrong!", "Error", ""); */
            this.authService.getConstantsMsg("1015").then((translatedMsg) => {
              const defaultMsg = {
                message: {
                  line_1: "something went wrong!",
                  line_2: "",
                },
                style: {
                  icon: "tick circle error.svg",
                  type: "error",
                },
              };
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            }).catch((error) => {
              return error;
            });
          }
        },
        (err) => {
          return err;
        }
      );
    } catch (e) {
      return e;
    }
  }

  getPSLines(products) {
    let count = 0;
    if (products) {
      products?.map((product) => {
        count += product?.total_lines;
      });
    }

    return count;
  }

  // getSyndicateStatus(syndicate: Data) {
  //   if (syndicate.cardType === "Private") {
  //     if (syndicate.status.toLowerCase().trim() === "paused") {
  //       return "Paused";
  //     }
  //     if (syndicate?.type.toLowerCase().trim() === "oneoff") {
  //       return "One-off";
  //     } else if (syndicate?.type.toLowerCase().trim() === "ongoing") {
  //       return "Ongoing";
  //     }
  //   }

  //   if (syndicate.syndicate_status.toLowerCase().trim() === "left") {
  //     return "Left";
  //   }
  //   if (syndicate.syndicate_status.toLowerCase().trim() === "deactive") {
  //     return "Deactive";
  //   }
  //   if (syndicate.syndicate_status.toLowerCase().trim() === "paused") {
  //     return "Paused";
  //   }
  //   if (syndicate?.syndicate_type.toLowerCase().trim() === "oneoff") {
  //     return "One-off";
  //   } else if (syndicate?.syndicate_type.toLowerCase().trim() === "ongoing") {
  //     return "Ongoing";
  //   }
  // }

  // This method has been used to show win more promise popup
  showPromisePopup() {
    try {
      const syndicateDetails = this.syndicate;
      const syndicateStatus = syndicateDetails?.syndicate_status;
      if (syndicateDetails?.syndicate_status === "active" &&
        syndicateDetails?.win_more_end === false) {
        this.matDialog.open(WinMorePromisePopupComponent, {
          panelClass: "win-Promise-popup",
          data: this.syndicate,
        });

      } else {
        const translatedMsg = {
          message: {
            line_1: `syndicate status ${syndicateStatus}`,
            line_2: "",
          },
          style: {
            duration: 2000,
            icon: "tick circle error.svg",
            type: "Error",
          },
        };
        const defaultMsg = {
          message: {
            line_1: `syndicate status ${syndicateStatus}`,
            line_2: "",
          },
          style: {
            icon: "tick circle error.svg",
            type: "Error",
          },
        };
        this.authService.showToastMessage(translatedMsg, defaultMsg);
      }
    } catch (error) {
      return error;
    }
  }

}
